import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-input-filled p-formgrid p-grid p-pb-2 p-px-2" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-field p-col-12" }
const _hoisted_4 = { class: "p-col-12 p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('Squeeze.Login.RecoverPasswordInfoText')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { for: "userName" }, null, -1)),
      _createVNode(_component_InputText, {
        id: "userName",
        modelValue: _ctx.userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userName) = $event)),
        modelModifiers: { trim: true },
        required: "true",
        ref: "usernameInput",
        autofocus: "",
        onKeydown: _ctx.onKeyDown
      }, null, 8, ["modelValue", "onKeydown"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        loading: _ctx.loading,
        disabled: _ctx.userName.length === 0,
        label: _ctx.$t('Squeeze.Login.Send'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickSend()))
      }, null, 8, ["loading", "disabled", "label"])
    ])
  ]))
}